<!-- Overlay de rate limiting -->
<app-rate-limit-overlay></app-rate-limit-overlay>

<!-- Contenido normal (se oculta cuando hay rate limiting) -->
<div *ngIf="!rateLimitActive" class="normal-content">
<div class="web">
  <div class="consultaContainer">
      <div class="consultaCenter">
        <div style="margin-top: 5rem; padding-top: 5rem;">
            <p><br/></p>
        </div>
        <div class="container-fluid mt-1" style="padding: 0;">
                <!--daet ini-->
                <div class="no-resultados-container" *ngIf="!fResultados">
                  <div class="no-resultados-icon">
                    <i class="fas fa-search"></i>
                  </div>

                  <h3 class="no-resultados-title">No se encontraron resultados</h3>

                  <div class="search-info-card">
                    <div class="search-criteria-compact">
                      <span *ngIf="searchTerm" class="criteria-item-compact">
                        <strong>Búsqueda:</strong> "{{searchTerm}}"
                      </span>
                      <span *ngIf="searchStartDate && searchEndDate" class="criteria-item-compact">
                        <strong>Período:</strong> {{searchStartDate | date: 'dd/MM/yyyy'}} - {{searchEndDate | date: 'dd/MM/yyyy'}}
                      </span>
                      <span class="criteria-item-compact">
                        <strong>Categoría:</strong> {{getCategoryName(searchCategory)}}
                      </span>
                    </div>
                  </div>

                  <div class="suggestions-section-compact">
                    <p class="suggestion-text">
                      <i class="bi bi-lightbulb"></i>
                      Verifica la ortografía, las fechas o intenta con otras palabras clave.
                    </p>
                  </div>

                  <!-- Sugerencia de categoría opuesta si aplica -->
                  <div class="category-suggestion" *ngIf="getOppositeCategory()">
                    <p class="suggestion-message">
                      ¿No encontraste lo que buscabas en <strong>{{getCategoryName(searchCategory)}}</strong>?
                    </p>
                    <a [routerLink]="['/consultas']" [queryParams]="{
                      q: searchTerm || null,
                      fi: searchStartDate || null,
                      ff: searchEndDate || null,
                      cat: getOppositeCategory(),
                      page: 1
                    }" class="btn-search-other">
                      <i class="bi bi-arrow-right-circle"></i>
                      Buscar en {{getCategoryName(getOppositeCategory())}}
                    </a>
                  </div>

                  <!-- Enlaces a colecciones -->
                  <div class="explore-collections-compact">
                    <p class="explore-text">O explora:</p>
                    <div class="collections-links">
                      <a [routerLink]="['/fotografias']" class="collection-link">
                        <i class="bi bi-camera-fill"></i> Fotografías
                      </a>
                      <a [routerLink]="['/portadas']" class="collection-link">
                        <i class="bi bi-newspaper"></i> Páginas Históricas
                      </a>
                    </div>
                  </div>
                </div>

                <div class="row" style="margin: 0;padding: 0; padding-top: 1rem;">
                  <div class="col-sm-12" style="margin: 0;padding: 0;">
                    <div *ngIf="fResultados">
                      <p style="margin: 5px;padding: 0;">
                        <span class="tituloPanel">Búsqueda</span>
                      </p>
                      <p style="margin: 0;padding: 0;" *ngIf="searchStartDate && searchEndDate">
                        <span class="titulo">Rango: {{searchStartDate | date: 'dd/MM/yyyy'}} - {{searchEndDate | date: 'dd/MM/yyyy'}}</span>
                      </p>
                      <p style="margin: 5px 0; padding: 0;">
                        <span class="resultados-text">
                          {{ listProductos.response.nroTotalFilas }} {{ listProductos.response.nroTotalFilas === '1' ? 'resultado encontrado' : 'resultados encontrados' }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <!--daet fin-->

                <!-- Paginación superior -->
                <div class="col-sm-12 text-center" *ngIf="fResultados && totalPaginas > 1">
                  <nav class="my-4">
                    <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                        <!--First-->
                        <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">Primero</a></li>
                        <!--Arrow left-->
                        <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                            <a class="page-link" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                                <span class="sr-only">Anterior</span>
                            </a>
                        </li>
                        <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                        <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                            <a class="page-link" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                                <span class="sr-only">Siguiente</span>
                            </a>
                        </li>
                        <!--Last-->
                        <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">Último</a></li>
                    </ul>
                </nav>
                </div>

                <div class="row" *ngIf="!fMerchadising">
                  <!-- Galería tipo masonry (igual que fotografías) -->
                  <div class="contenedor-galeria">
                    <div class="columna-galeria" *ngFor="let columna of columnas">
                      <div class="item-galeria" *ngFor="let item of columna">
                        <div class="panelLibWeb" *ngIf="fResultados"
                             [routerLink]="item.categoryName === 'FOTOGRAFIAS' ? ['/dt/', item.titleShowUrl, item.id] : item.categoryName === 'PORTADAS_HISTORICAS' ? ['/dtp/', item.titleShowUrl, item.id] : ['/dt/', item.titleShowUrl, item.id]"
                             style="cursor: pointer;"
                             (mousemove)="onMouseMove($event)"
                             (mouseleave)="onMouseLeave($event)">
                          <div class="container-fluid" style="padding: 0;">
                            <div class="row">
                              <div class="col-sm-6" style="padding: 0 15px;">
                                <!-- Skeleton SIN marco -->
                                <div *ngIf="shouldShowSkeleton(item.activoId)"
                                     [style.width]="'100%'"
                                     [style.aspect-ratio]="getSkeletonAspectRatio(item)">
                                  <app-image-skeleton
                                    [width]="'100%'"
                                    [height]="'100%'"
                                    size="medium">
                                  </app-image-skeleton>
                                </div>

                                <!-- Imagen CON marco (solo cuando está cargada) -->
                                <div class="marco-container" *ngIf="!shouldShowSkeleton(item.activoId)">
                                  <div class="imagen-container-holografico">
                                    <ng-container *ngIf="getProtectedImageUrl(item.activoId)">
                                      <img class="img-fluid-sin-marco"
                                        [src]="getProtectedImageUrl(item.activoId)"
                                        width="100%"
                                        style="padding: 0;"
                                        alt="{{ item.title }} - Imagen Protegida"
                                      />
                                    </ng-container>
                                  </div>
                                </div>

                                <!-- Ver detalle completo debajo de la imagen -->
                                <div class="ver-mas-indicator">
                                  <span>Ver detalle completo</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M5.5 7a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L11.293 7H5.5z"/>
                                  </svg>
                                </div>
                              </div>
                              <div class="col-sm-6" style="padding: 0; padding-right: 5px; text-align: left; position: relative;">
                                <p class="tituloFoto">{{item.title}}</p>
                                <p class="descripcionFoto">{{item.subtitle}}</p>
                                <p class="descripcionFoto">{{item.description}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Paginación inferior -->
                  <div class="col-sm-12 text-center paginacion-bottom" *ngIf="fResultados && totalPaginas > 1">
                    <nav class="my-4">
                        <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                            <!--First-->
                            <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">&#171;&#171;</a></li>
                            <!--Arrow left-->
                            <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                                <a class="page-link" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                    <span class="sr-only">Anterior</span>
                                </a>
                            </li>
                            <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                            <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                                <a class="page-link" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                    <span class="sr-only">Siguiente</span>
                                </a>
                            </li>
                            <!--Last-->
                            <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">&#187;&#187;</a></li>
                        </ul>
                    </nav>
                  </div>
                </div>
                <div class="row" *ngIf="fMerchadising">
                  <div class="col-sm-4" *ngFor="let item of listMerchadising.response.list">
                       
                    <div class="panelLib">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-6">
                                  <img class="imgPreview" src="{{item.image}}">
                                </div>
                                <div class="col-sm-6">
                                    <p class="titulo">{{item.title}}</p>
                                    <p class="descripcion">{{item.subtitle}}</p>
                                    <p class="precio">S/ {{item.price}}</p>                                        
                                    <a class="btn btnDetalle" [routerLink]="['/detalleSourvenir/',item.id]">Ver Detalle</a><br/>
                                    <!-- <a class="btn btnComprar">Comprar</a><br/> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                </div>
        </div>
      </div>
  </div>
</div>

<!-- Versión móvil -->
<div class="movil">
  <div class="consultaContainer">
      <div class="contentFotoCenterM">
        <div style="margin-top: 5rem; padding-top: 1.5rem;">
            <p><br/></p>
        </div>
        <div style="margin-top: 0.5rem;">
                <!-- Mensaje sin resultados -->
                <div class="no-resultados-container" *ngIf="!fResultados">
                  <div class="no-resultados-icon">
                    <i class="fas fa-search"></i>
                  </div>

                  <h3 class="no-resultados-title">No se encontraron resultados</h3>

                  <div class="search-info-card">
                    <div class="search-criteria-compact">
                      <span *ngIf="searchTerm" class="criteria-item-compact">
                        <strong>Búsqueda:</strong> "{{searchTerm}}"
                      </span>
                      <span *ngIf="searchStartDate && searchEndDate" class="criteria-item-compact">
                        <strong>Período:</strong> {{searchStartDate | date: 'dd/MM/yyyy'}} - {{searchEndDate | date: 'dd/MM/yyyy'}}
                      </span>
                      <span class="criteria-item-compact">
                        <strong>Categoría:</strong> {{getCategoryName(searchCategory)}}
                      </span>
                    </div>
                  </div>

                  <div class="suggestions-section-compact">
                    <p class="suggestion-text">
                      <i class="bi bi-lightbulb"></i>
                      Verifica la ortografía, las fechas o intenta con otras palabras clave.
                    </p>
                  </div>

                  <!-- Sugerencia de categoría opuesta si aplica -->
                  <div class="category-suggestion" *ngIf="getOppositeCategory()">
                    <p class="suggestion-message">
                      ¿No encontraste lo que buscabas en <strong>{{getCategoryName(searchCategory)}}</strong>?
                    </p>
                    <a [routerLink]="['/consultas']" [queryParams]="{
                      q: searchTerm || null,
                      fi: searchStartDate || null,
                      ff: searchEndDate || null,
                      cat: getOppositeCategory(),
                      page: 1
                    }" class="btn-search-other">
                      <i class="bi bi-arrow-right-circle"></i>
                      Buscar en {{getCategoryName(getOppositeCategory())}}
                    </a>
                  </div>

                  <!-- Enlaces a colecciones -->
                  <div class="explore-collections-compact">
                    <p class="explore-text">O explora:</p>
                    <div class="collections-links">
                      <a [routerLink]="['/fotografias']" class="collection-link">
                        <i class="bi bi-camera-fill"></i> Fotografías
                      </a>
                      <a [routerLink]="['/portadas']" class="collection-link">
                        <i class="bi bi-newspaper"></i> Páginas Históricas
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Header de resultados -->
                <div class="row" style="margin: 0;padding: 0; padding-top: 0.5rem;">
                  <div class="col-sm-12" style="margin: 0;padding: 0;">
                    <div *ngIf="fResultados">
                      <p style="margin: 0;padding: 0;">
                        <span class="tituloPanel">Búsqueda</span>
                      </p>
                      <p style="margin: 0;padding: 0;" *ngIf="searchStartDate && searchEndDate">
                        <span class="titulo">Rango: {{searchStartDate | date: 'dd/MM/yyyy'}} - {{searchEndDate | date: 'dd/MM/yyyy'}}</span>
                      </p>
                      <p style="margin: 5px 0; padding: 0;">
                        <span class="resultados-text">
                          {{ listProductos.response.nroTotalFilas }} {{ listProductos.response.nroTotalFilas === '1' ? 'resultado encontrado' : 'resultados encontrados' }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Paginación superior -->
                <div class="col-sm-12 text-center" *ngIf="fResultados && totalPaginas > 1">
                  <nav class="my-4">
                    <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                        <!--First-->
                        <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">Primero</a></li>
                        <!--Arrow left-->
                        <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                            <a class="page-link" aria-label="Previous">
                                <span aria-hidden="true">&laquo;</span>
                                <span class="sr-only">Anterior</span>
                            </a>
                        </li>
                        <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                        <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                            <a class="page-link" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                                <span class="sr-only">Siguiente</span>
                            </a>
                        </li>
                        <!--Last-->
                        <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">Último</a></li>
                    </ul>
                </nav>
                </div>

                <div class="row" *ngIf="!fMerchadising">
                  <div class="col-12 col-md-6 col-lg-4" *ngFor="let item of listProductos?.response?.list" style="padding: 0;">
                    <div class="panelLibMovil" *ngIf="fResultados" style="cursor: pointer;" [routerLink]="item.categoryName === 'FOTOGRAFIAS' ? ['/dt/', item.titleShowUrl, item.id] : item.categoryName === 'PORTADAS_HISTORICAS' ? ['/dtp/', item.titleShowUrl, item.id] : ['/dt/', item.titleShowUrl, item.id]">
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-6">
                            <!-- Skeleton SIN marco -->
                            <div *ngIf="shouldShowSkeleton(item.activoId)"
                                 class="skeleton-container"
                                 style="width: 100%; margin-top: 5px;"
                                 [style.aspect-ratio]="getSkeletonAspectRatio(item)">
                              <app-image-skeleton
                                [width]="'100%'"
                                [height]="'100%'"
                                size="large"
                                [class]="getSkeletonOrientationClass(item.activoId)">
                              </app-image-skeleton>
                            </div>

                            <!-- Imagen CON marco holográfico (solo cuando está cargada) -->
                            <a *ngIf="!shouldShowSkeleton(item.activoId)"
                               class="btnDetalleFoto"
                               >
                              <div class="marco-container-mobile">
                                <div class="imagen-container-holografico-mobile">
                                  <ng-container *ngIf="getProtectedImageUrl(item.activoId)">
                                    <img [src]="getProtectedImageUrl(item.activoId)"
                                         width="100%"
                                         alt="{{item.title}} - Imagen Protegida">
                                  </ng-container>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div class="col-6" style="text-align: left;">
                            <p class="tituloFoto">{{item.title}}</p>
                            <p class="descripcionFoto">{{item.subtitle}}</p>
                            <p></p>
                            <p class="descripcionFoto">{{item.description}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Paginación inferior -->
                  <div class="col-sm-12 text-center paginacion-bottom" *ngIf="fResultados && totalPaginas > 1">
                    <nav class="my-4">
                        <ul class="pagination pagination-circle pg-red mb-0 justify-content-center">
                            <!--First-->
                            <li class="page-item" (click)="cambiarPagina(1)"><a class="page-link">&#171;&#171;</a></li>
                            <!--Arrow left-->
                            <li class="page-item" (click)="cambiarPagina(paginaActual-1)">
                                <a class="page-link" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                    <span class="sr-only">Anterior</span>
                                </a>
                            </li>
                            <li class="page-item {{active(a+1)}}" *ngFor="let a of filterRange(totalPaginasArray,rangoInicio,rangoFin); let i = index"><a (click)="cambiarPagina(a+1)" class="page-link ">{{a+1}}</a></li>
                            <li class="page-item" (click)="cambiarPagina(paginaActual+1)">
                                <a class="page-link" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                    <span class="sr-only">Siguiente</span>
                                </a>
                            </li>
                            <!--Last-->
                            <li class="page-item"  (click)="cambiarPagina(totalPaginas)"><a class="page-link">&#187;&#187;</a></li>
                        </ul>
                    </nav>
                  </div>
                </div>

                <!-- Merchadising móvil -->
                <div class="row" *ngIf="fMerchadising">
                  <div class="col-12" *ngFor="let item of listMerchadising.response.list">
                    <div class="panelLibMovil">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12 text-center">
                                  <img class="imgPreview" src="{{item.image}}" style="width: 100%; max-width: 250px;">
                                </div>
                                <div class="col-12" style="margin-top: 15px;">
                                    <p class="titulo">{{item.title}}</p>
                                    <p class="descripcion">{{item.subtitle}}</p>
                                    <p class="precio">S/ {{item.price}}</p>
                                    <a class="btn btnDetalle" [routerLink]="['/detalleSourvenir/',item.id]">Ver Detalle</a><br/>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
        </div>
      </div>
  </div>
</div>
</div>
<!-- Fin del contenido normal -->
